
import { mapState } from 'vuex'
import LayoutMixin from '@/mixins/layout'
import SupportTop from '@/components/page/support-top.vue'
import SupportNav from '@/components/page/support-nav.vue'
export default {
  components: {
    SupportNav,
    SupportTop,
  },
  mixins: [LayoutMixin],
  async asyncData({ app, route, redirect }) {
    const { site, lang } = route.params
    // 日本站访问此页面，重定向到 about/address
    if (site && site.toUpperCase() === 'JP') {
      redirect(`/${site}/${lang}/about/address`)
      return {}
    }
    try {
      const res = await app.$API.support.getSupportContent({ type: 8 })
      const { name = '', content = '' } = res[0] || {}
      return {
        name,
        content,
      }
    } catch (error) {
      return {
        name: '',
        content: '',
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
    }),
    isSG() {
      return this.site.toUpperCase() === 'SG'
    },
    getMainTitle() {
      return !this.isSG
        ? this.$t('navs.authReseller')
        : this.$t('serviceSupport.querySupport.service_dept')
    },
  },
}
